module.exports = __webpack_public_path__ + "img/40_9.97d0831c.png";